<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // Removed.by.KWShin.2024.03.08. liquidChartable.js에 이미 선언되어 있음.
    // title: String,
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.03.29.
    title() {
      return this.$t('dv.title.sssn');
    },
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  methods: {
    setData(data) {
      this.data.value = data.reduce((acc, item) => (acc += parseInt(item.extmodi)), 0);
    },
  },
};
</script>
